import React, { useContext, useEffect } from "react";

import {
  ButtonBack,
  ButtonNext,
  DotGroup,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { CarouselContext } from "pure-react-carousel";
// import Arrow from "/public/arrow.svg";
import useWindowSize from "./windowSizer";

const CarouselSlider = ({ setSlideCount, setCurrentSlide }) => {
  const screenWidth = useWindowSize();
  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    const updateCarouselSlide = (slideToBeVisible) => {
      const { currentSlide, totalSlides, visibleSlides } =
        carouselContext.state;
      setSlideCount(slideToBeVisible);

      if (
        currentSlide >= totalSlides - visibleSlides ||
        currentSlide >= totalSlides - slideToBeVisible
      ) {
        setCurrentSlide(totalSlides - slideToBeVisible);
      }
    };

    if (screenWidth < 832) {
      updateCarouselSlide(1);
    } else if (screenWidth < 1088) {
      updateCarouselSlide(2);
    } else {
      updateCarouselSlide(3);
    }
  }, [screenWidth, setSlideCount, setCurrentSlide, carouselContext]);

  return (
    <div>
      <Slider>
        <Slide index={0} className="slide">
          <div className="content">
          <div className="row">
          <div className="col-lg-4 mt-5">
            <article className="sol_meme_card cd-margin">
              <div className="sol_meme_card-img">
                <div className="sol_meme_card-imgs">
                  <img
                    src={require("../../image/solana_meme_coin/Images/Doge.webp")}
                  />
                </div>
              </div>
              <div className="solana_card_title">
                <h3>Dogecoin</h3>
                <p>DOGE</p>
              </div>

              <div className="project-info">
                <div className="flex">
                  <div className="market_cap">
                    <p>Market cap</p>
                    <h4>$30,090,625,440</h4>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
          </div>
        </Slide>
        <Slide index={1}>
          <div className="content">
          <div className="row">
          <div className="col-lg-4 mt-5">
            <article className="sol_meme_card">
              <div className="sol_meme_card-img">
                <div className="sol_meme_card-imgs">
                  <img
                    src={require("../../image/solana_meme_coin/Images/Shib.webp")}
                  />
                </div>
              </div>
              <div className="solana_card_title">
                <h3>Shiba Inu</h3>
                <p>SHIB</p>
              </div>

              <div className="project-info">
                <div className="flex">
                  <div className="market_cap">
                    <p>Market cap</p>
                    <h4>$17,837,888,095</h4>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
          </div>
        </Slide>
        <Slide index={2}>
          <div className="content">
          <div className="row">
          <div className="col-lg-4 mt-5 col-sm-12">
            <article className="sol_meme_card">
              <div className="sol_meme_card-img">
                <div className="sol_meme_card-imgs">
                  <img
                    src={require("../../image/solana_meme_coin/Images/floki.webp")}
                  />
                </div>
              </div>
              <div className="solana_card_title">
                <h3>Floki Inu</h3>
                <p>DOGE</p>
              </div>

              <div className="project-info">
                <div className="flex">
                  <div className="market_cap">
                    <p>Market cap</p>
                    <h4>$2,345,747,217  </h4>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
          </div>{" "}
        </Slide>
        <Slide index={3}>
          <div className="content">
          <div className="row">
          <div className="col-lg-4 mt-5 col-sm-12">
            <article className="sol_meme_card">
              <div className="sol_meme_card-img">
                <div className="sol_meme_card-imgs">
                  <img
                    src={require("../../image/solana_meme_coin/Images/babydoge.webp")}
                  />
                </div>
              </div>
              <div className="solana_card_title">
                <h3>Baby Doge Coin</h3>
                <p>BABYDOGE</p>
              </div>

              <div className="project-info">
                <div className="flex">
                  <div className="market_cap">
                    <p>Market cap</p>
                    <h4>$347,200,368</h4>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
          </div>
        </Slide>
        <Slide index={4}>
          <div className="content">
          <div className="row">
          <div className="col-lg-4 mt-5 col-sm-12">
            <article className="sol_meme_card">
              <div className="sol_meme_card-img">
                <div className="sol_meme_card-imgs">
                  <img
                    src={require("../../image/solana_meme_coin/Images/wif_coin.webp")}
                  />
                </div>
              </div>
              <div className="solana_card_title">
                <h3>Dog Wif Hat</h3>
                <p>WIF</p>
              </div>

              <div className="project-info">
                <div className="flex">
                  <div className="market_cap">
                    <p>Market cap</p>
                    <h4>$51,600,939</h4>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
          </div>
        </Slide>
        {/* <Slide index={5}>
        
        </Slide> */}
      </Slider>
      <div className="controls">
        <ButtonBack className="btn-arrow reverse-arrow">
          <img src={require('../../image/solana_meme_coin/Images/leftarr.webp')} alt="arrow" />
        </ButtonBack>
        <ButtonNext className="btn-arrow">
        <img src={require('../../image/solana_meme_coin/Images/rightarr.webp')} alt="arrow" />
          
        </ButtonNext>
      </div>
    </div>
  );
};

export default CarouselSlider;
